import { cellPhoneBr } from "./formatByText";

export function onChangeCurrencyMask(
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
): void {
  let currency: string | number = e.target.value.replace(/\D/g, "");
  currency = Number(currency);
  currency = `${(currency / 100).toFixed(2)}`;
  currency = currency.replace(".", ",");
  currency = currency.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
  currency = currency.replace(/(\d)(\d{3}),/g, "$1.$2,");
  e.target.value = `R$ ${currency}`;
}

export function clienteIdMask(cell: string): string {
  let v = cell;
  v = v.replace(/(\d{8})(\d{4})(\d{4})(\d{4})(\d{12})/g, "$1-$2-$3-$4-$5");

  return v;
}

export function onChangeCellMaskBr(e: React.ChangeEvent<HTMLInputElement>) {
  return cellPhoneBr(e.target.value);
}

export function onChangeClienteIdMask(e: React.ChangeEvent<HTMLInputElement>) {
  return clienteIdMask(e.target.value);
}
